import React from 'react';
import { WifiOff } from 'lucide-react';
import type { DiligenceDocumentRun } from '../types';
import DiligenceDocumentRunCard from './DiligenceDocumentRunCard';
import { getActivityStartTime } from '../utils/documentActivityTiming';

interface TypingIndicatorProps {
  startTime: number;
  isOffline?: boolean;
  run?: DiligenceDocumentRun;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ startTime, isOffline = false, run }) => {
  // A retry keeps the historical message until its first fresh progress event arrives.
  const runStart = getActivityStartTime(run);
  const currentRun = run?.status === 'running' && runStart !== undefined && runStart >= startTime ? run : undefined;
  if (!isOffline) return <DiligenceDocumentRunCard turnStartedAtMs={startTime} run={currentRun ?? {
    version: 1, status: 'running', stage: 'received', startedAtMs: startTime,
    timingComplete: true, documentaryWorkStarted: false, events: []
  }} />;

  return (
    <div className="flex w-full mb-1 justify-start animate-message-appear" role="status" aria-live="polite" aria-atomic="true">
      <div className="flex max-w-full items-start gap-3 px-3 py-1.5 text-ink">
        <WifiOff size={19} className="mt-0.5 shrink-0 text-warning" aria-hidden="true" />
        <div className="min-w-0">
          <span className="block text-[14px] font-semibold leading-relaxed text-warning md:text-[15px]">Sin conexión</span>
          <span className="mt-0.5 block text-xs font-medium text-warning/80">Seguiré comprobando la respuesta cuando vuelva Internet.</span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
